"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigunguSpan = exports.AutoCompleteMatchSpan = exports.AutoCompleteImgBox = exports.AutoCompleteContentDiv = exports.AutoCompleteButtonA = exports.AutoCompleteItemDiv = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.AutoCompleteItemDiv = styled_components_1.default.div `
  position: relative;

  width: 100%;

  &:first-child {
    margin-top: ${(props) => props.marVertical ? "0" : props.isKeyword ? "8px" : "12px"};
  }

  &:hover {
    background-color: #eaeaea;

    .Vertical__Focus {
      background-color: #0ac7ce;
    }
  }

  a:focus {
    background-color: #eaeaea;

    .Vertical__Focus {
      background-color: #0ac7ce;
    }
  }
  &.active {
    background-color: #eaeaea;

    .Vertical__Focus {
      background-color: #0ac7ce;
    }
  }

  margin-bottom: ${(props) => (props.isLastKeyword ? "4px" : "")};
  border-bottom: ${(props) => (props.isLastKeyword ? "3px solid #eaeaea" : "")};
  padding-bottom: ${(props) => (props.isLastKeyword ? "4px" : "")};
`;
exports.AutoCompleteButtonA = styled_components_1.default.a `
  display: flex;
  align-items: center;

  gap: ${(props) => (props.fontExpand ? "1.25rem" : "0.9375rem")};

  width: 100%;
  height: ${(props) => props.isKeyword
    ? "38px"
    : props.marVertical
        ? `calc(3.625rem + ${props.marVertical} + ${props.marVertical})`
        : "3.625rem"};

  padding: 0 ${(props) => (props.fontExpand ? "1.625rem" : "1.25rem")} 0
    ${(props) => (props.fontExpand ? "2.1875rem" : "1.25rem")};
  /* padding: 0 1.25rem; */
`;
exports.AutoCompleteContentDiv = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  width: 100%;
  height: ${(props) => (props.isKeyword ? "" : "41px")};

  .Auto__Complete__Item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .Auto__Complete__Text {
    text-align: left;
    font-size: ${(props) => (props.fontExpand ? "1.125rem" : "0.9375rem")};
    letter-spacing: ${(props) => props.fontExpand ? "-0.0563rem" : "-0.0469rem"};
    line-height: ${(props) => (props.fontExpand ? "1.625rem" : "1.344rem")};
    color: #202020;

    .Auto__Complete__MatchBranch {
      font-weight: 500;
      color: ${(props) => (props.isKeyword ? "#2c87f1" : "#19b7c2")};
    }
  }

  .Auto__Complete__Addr {
    overflow: hidden;

    white-space: nowrap;
    text-align: left;
    font-size: ${(props) => (props.fontExpand ? "0.9375rem" : "0.8125rem")};
    letter-spacing: ${(props) => props.fontExpand ? "-0.0469rem" : "-0.0406rem"};
    line-height: ${(props) => (props.fontExpand ? "1.3125rem" : "1.1875rem")};
    color: #7e7e7e;
  }

  .Auto__Complete__Info {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;

    height: 100%;

    font-size: ${(props) => (props.fontExpand ? "0.9375rem" : "0.8125rem")};
    letter-spacing: ${(props) => props.fontExpand ? "-0.0469rem" : "-0.0406rem"};
    line-height: ${(props) => (props.fontExpand ? "1.3125rem" : "1.1875rem")};
    color: #9e9e9e;
  }

  .Auto__Complete__Branch {
    overflow: hidden;

    display: flex;
    align-items: flex-start;

    ${(props) => {
    if (props.preventReplace === true)
        return;
    const $inputwrap = document.body.querySelector(".Input__Wrap");
    if ($inputwrap && $inputwrap.clientWidth <= 540) {
        return "max-width: 100px;";
    }
}}

    white-space: nowrap;
  }
`;
exports.AutoCompleteImgBox = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;

  height: ${(props) => (props.isKeyword ? "" : "41px")};

  .Auto__Complete__Item__Img {
    position: relative;
    top: ${(props) => (props.isKeyword ? "0" : "0.1875rem")};

    //${(props) => (props.fontExpand ? "0.25rem" : "0.1875rem")}

    width: ${(props) => props.isKeyword
    ? "15px"
    : props.fontExpand
        ? "1rem"
        : "0.9375rem"} !important;
    height: ${(props) => props.isKeyword
    ? "15px"
    : props.fontExpand
        ? "1.3125rem"
        : "1.25rem"} !important;
  }

  .Auto__Complete__Distance {
    position: absolute;
    bottom: ${(props) => (props.fontExpand ? "-0.3125rem" : "0.0625rem")};

    text-align: center;
    font-size: ${(props) => (props.fontExpand ? "0.8125rem" : "0.75rem")};
    letter-spacing: ${(props) => props.fontExpand ? "-0.0406rem" : "-0.0375rem"};
    line-height: ${(props) => (props.fontExpand ? "1.1875rem" : "1.0625rem")};
    color: ${(props) => (props.fontExpand ? "#9e9e9e" : "#8e8e8e")};
  }
`;
exports.AutoCompleteMatchSpan = styled_components_1.default.span `
  line-height: 1.3125rem;
  font-weight: 500;
  color: #2c87f1;
`;
exports.SigunguSpan = styled_components_1.default.span `
  margin-left: 4px;
  color: #7e7e7e;
  font-size: 13px;
`;
